.root {
  position: absolute;
  inset: 0;
  overflow: hidden;
  touch-action: none;
  cursor: default;
  user-select: none;
  -webkit-user-select: none;
  background: var(--field);
}

.background {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  display: block;
}

.world {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  transform-origin: 0 0;
  will-change: transform;
  z-index: var(--z-world);
}

.marquee {
  position: absolute;
  border: 1px solid var(--focus);
  background: var(--focus-soft);
  pointer-events: none;
}

.overlay {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: var(--z-overlay);
}

.empty {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 0 32px;
  text-align: center;
  color: var(--ink-faint);
  font-style: italic;
}

.root[data-mode='pan'] {
  cursor: grabbing;
}
.root[data-mode='hover'],
.root[data-mode='press'] {
  cursor: grab;
}
.root[data-mode='drag'] {
  cursor: grabbing;
}
.root[data-mode='marquee'] {
  cursor: crosshair;
}
.root[data-mode='connect'] {
  cursor: crosshair;
}

.guide {
  position: absolute;
  pointer-events: none;
  background: var(--focus);
  opacity: 0.85;
}

.guide[data-axis='x'] {
  width: 1px;
}

.guide[data-axis='y'] {
  height: 1px;
}

.guide[data-kind='center'] {
  background: repeating-linear-gradient(to bottom, var(--focus) 0 4px, transparent 4px 8px);
}

.guide[data-axis='y'][data-kind='center'] {
  background: repeating-linear-gradient(to right, var(--focus) 0 4px, transparent 4px 8px);
}

.connectPreview {
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  overflow: visible;
  pointer-events: none;
}

.connectPreview line {
  stroke: var(--focus);
  stroke-width: 1.5;
  stroke-dasharray: 6 4;
  vector-effect: non-scaling-stroke;
}

.connectPreview[data-target] line {
  stroke-dasharray: none;
}
